/**
 * Opens a URL in a new browser window/tab.
 * 
 * This is a workaround for the behavior of _blank links in PWA (Progressive Web App) mode.
 * In PWA mode, `window.open()` with `_blank` sometimes opens within the PWA context
 * instead of the system browser. Using an anchor element with target="_blank" and
 * rel="noopener noreferrer" is more reliable.
 */
export function openInNewWindow(url: string): void {
	const link = document.createElement('a');
	link.href = url;
	link.target = '_blank';
	link.rel = 'noopener noreferrer';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

export function isMobile(): boolean {
	return window.innerWidth < 768;
}
